import MainHeaderSearchBar from "../../components/search-bar/search-bar";
import SearchBarResults from "../../components/search-bar-results/search-bar-results";
import { useMemo, useState } from "react";
import { CartEmpty } from "../../components/cart-empty";
import { MainHeaderEvents } from "../../main-header.events";
import styles from "./header-3.module.css";
import { UiButton } from "@ui-monorepo/index";
import { MainHeaderSideMenu } from "../../components/main-header-sidebar-menu";
import { InformationBar } from "../../../../";
import { HEADER_CATEGORIES_EXTEND_ITEMS } from "../../main-header.constants";
import { useMainHeader } from "../../main-header.hook";
import { HeaderVmProps } from "../../types";
import {
  TemplateType,
  AppLink,
  makeUrl,
  useCatalogue,
  categoryNormalize,
  useAppLocation } from
"@commons-monorepo/index";
import { getRedirectStore } from "../../util/redirect-path";

const Header3 = ({
  overBanner,
  sticky,
  className,
  categories,
  hasServices,
  hasOffers,
  hasWholesale,
  theme,
  data,
  isPortraitInView,
  ComponentLinks,
  goToCheckout
}: HeaderVmProps) => {
  const {
    t,
    logEvent,
    themeContext,
    storeMetadata,
    cartProductsQuantity,
    showSearchBar,
    isLoggedIn,
    showCartEmpty,
    showCategoriesMenu,
    showProfileMenu,
    isPopUpDetailOpen,
    creatingShoppingCart,
    setShowCartEmpty,
    handleOnSearch,
    handleShowLogin,
    handleCloseSession,
    handleCartButton,
    handleShowStoreInfo,
    setShowProfileMenu,
    setShowSearchBar,
    suggestedProducts,
    setSuggestedProducts,
    valueToSearch,
    setValueToSearch,
    partnerProfilePicture,
    informationBar,
    informationBarOffer,
    categoriesChunks,
    categoriesListRef,
    categoryListSelected,
    handleShowCategoriesList,
    handleSelectCategoryList,
    handleClickOnCategory,
    storeUserPathName,
    checkLogo,
    showStoreVerification,
    SHOW_LOGIN_BUTTON
  } = useMainHeader({ data, theme, goToCheckout, isPortraitInView });

  const { isInCategoryView, isInCatalogueRoot } = useCatalogue({
    storeMetadata
  });
  const { pathname } = useAppLocation();
  const [showHeaderDetail, setShowHeaderDetail] = useState(false);
  const handleMenuButton = () => {
    setShowHeaderDetail(!showHeaderDetail);
    logEvent(MainHeaderEvents.SelectMenu);
  };
  const redirectUrl = useMemo(
    () => getRedirectStore(`/catalogo/${storeMetadata.userNetwork.urlSummer}`, storeMetadata.ownerId),
    []
  );

  const isSticky =
  sticky ||
  !isInCatalogueRoot ||
  themeContext.template.COVER === TemplateType.NONE;

  const isOverBanner =
  overBanner &&
  isInCatalogueRoot &&
  isPortraitInView &&
  themeContext.template.COVER !== TemplateType.NONE;

  const dataAboutUs = storeMetadata?.catalogueAboutUs;
  const menuItems = useMemo(() => {
    return [
    {
      link: `${pathname}/${makeUrl(pathname, `todos-los-productos`)}`,
      icon: "icon-bag",
      text: t("main_header.all_products"),
      onClick: () => {
        logEvent(MainHeaderEvents.SelectWebAllProductsDesktop, {
          Template_id: themeContext.templateId,
          platform: "web",
          user_type: "buyer",
          option: "all_products",
          method: "desktop"
        });
      }
    },
    ...(hasOffers ?
    [
    {
      link: `${pathname}/${makeUrl(pathname, `ofertas`)}`,
      text: t("main_header.seller"),
      onClick: () =>
      logEvent(MainHeaderEvents.SelectHeaderOffers, {
        Template_id: themeContext.templateId
      })
    }] :

    []),
    ...(hasWholesale ?
    [
    {
      link: `${pathname}/${makeUrl(pathname, `ventas-mayoreo`)}`,
      text: t("main_header.wholesale"),
      onClick: () =>
      logEvent(MainHeaderEvents.SelectHeaderWholesale, {
        Template_id: themeContext.templateId
      })
    }] :

    []),
    ...(hasServices ?
    [
    {
      link: `${pathname}/${makeUrl(pathname, `servicios`)}`,
      text: t("main_header.services"),
      onClick: () =>
      logEvent(MainHeaderEvents.SelectHeaderServices, {
        Template_id: themeContext.templateId
      })
    }] :

    []),
    ...(dataAboutUs ?
    [
    {
      link: `${pathname}/${makeUrl(pathname, `sobre-nosotros`)}`,
      text: t("main_header.about"),
      onClick: () =>
      logEvent(MainHeaderEvents.SelectWebAboutUsDesktop, {
        Template_id: themeContext.templateId
      })
    }] :

    []),
    {
      text: t("main_header.contact"),
      isActive: isPopUpDetailOpen,
      onClick: () => {
        handleShowStoreInfo();
        logEvent(MainHeaderEvents.SelectHeaderContactUs, {
          Template_id: themeContext.templateId
        });
      }
    }];

  }, [t, hasOffers, hasWholesale, hasServices, isPopUpDetailOpen, pathname]);

  return (
    <header
      className={`${styles.header3Styled} ${
      isOverBanner ? styles.header3OverBanner : ""
      } ${isSticky ? styles.header3Sticky : ""} ${className || ""}`}>

      {informationBar && !informationBar.hidden &&
      <div className={styles.headerInformationBar}>
          <InformationBar
          information={informationBar}
          offer={informationBarOffer}
          storeMetadata={data?.storeMetadata}
          ComponentLinks={ComponentLinks} />

        </div>}

      <div className={styles.headerContainer}>
        <div className={styles.header3Top}>
          <div className={styles.header3TopLeft}>
            <button
              role={"button"}
              className={`${styles.header3Button} ${styles.header3ButtonMenu}`}
              onClick={handleMenuButton}>

              <span
                className={`${styles.header3ButtonIcon} icon-burger-menu`} />

            </button>
            <div
              className={`${styles.header3SearchContainer} ${
              showSearchBar ? styles.show : ""
              }`}>

              <MainHeaderSearchBar
                valueToSearch={valueToSearch}
                setValueToSearch={setValueToSearch}
                setProducts={setSuggestedProducts}
                setShowSearchBar={setShowSearchBar}
                storeMetadata={storeMetadata}
                className={styles.desktopSearchBar}
                isMobile={data.isMobile}
                onSearch={handleOnSearch} />

              <SearchBarResults
                valueToSearch={valueToSearch}
                locale={storeMetadata?.locale}
                currency={storeMetadata?.currency}
                className={styles.searchBarResults}
                products={suggestedProducts}
                onSearch={handleOnSearch}
                storeMetadata={data?.storeMetadata} />

            </div>
          </div>
          <div className={styles.header3TopCenter}>
            <AppLink
              to={`${redirectUrl}`}
              className={styles.header3LinkHome}
              externalLink={redirectUrl.includes("https")}>

              <img
                src={partnerProfilePicture}
                alt={storeMetadata?.enterpriseName}
                className={`${styles.header3Logo} ${
                storeMetadata?.profilePicConfiguration?.enableRectangle &&
                styles.rectangle
                }`}
                loading='lazy' />

              {!!showStoreVerification &&
              <img src={checkLogo} alt='Check' className={styles.check} />}

            </AppLink>
          </div>
          <div className={styles.header3TopRight}>
            {SHOW_LOGIN_BUTTON && !isLoggedIn &&
            <UiButton
              className={styles.header3ButtonLogin}
              size='short'
              theme={theme}
              isWhite={overBanner && isInCatalogueRoot}
              isBlack={!isPortraitInView}
              onClick={handleShowLogin}>

                {t("main_header.sign_in")}
              </UiButton>}

            {SHOW_LOGIN_BUTTON && isLoggedIn &&
            <div
              className={`${styles.header3ProfileButton} ${
              showProfileMenu ? styles.active : ""
              }`}>

                <label
                className={`${styles.header3Button} ${styles.header3ButtonProfile}`}
                htmlFor='headerProfileItem'>

                  <span className={`${styles.header3ButtonIcon} icon-user`} />
                </label>
                <input
                type='text'
                id='headerProfileItem'
                onFocus={() => setShowProfileMenu(true)}
                onBlur={() =>
                setTimeout(() => setShowProfileMenu(false), 200)} />


                <ul
                className={`${styles.header3SubItems} ${styles.header3SubMenuContainer}`}>

                  <li className={styles.header3SubItem}>
                    <a
                    href={`/features/dashboard/perfil?partnerId=${storeUserPathName}`}
                    className={styles.header3SubMenuLink}
                    onClick={() =>
                    logEvent(MainHeaderEvents.SelectViewProfile, {
                      source: "header"
                    })}>


                      <span className='icon-user' />
                      {t("profile.profile_text")}
                    </a>
                  </li>
                  <li className={styles.header3SubItem}>
                    <a
                    href={`/features/dashboard/historial`}
                    className={styles.header3SubMenuLink}
                    onClick={() =>
                    logEvent(MainHeaderEvents.SelectPurchase, {
                      source: "header"
                    })}>


                      <span className='icon-bag' />
                      {t("profile.my_shopping")}
                    </a>
                  </li>
                  <li className={styles.header3SubItem}>
                    <UiButton
                    theme={theme}
                    className={`${styles.header3SubMenuLink} ${styles.danger}`}
                    onClick={handleCloseSession}>

                      <span className='icon-arrows-left-right' />
                      {t("profile.logout")}
                    </UiButton>
                  </li>
                </ul>
              </div>}

            <button
              role={"button"}
              aria-label='Botón buscar principal'
              className={`${styles.header3Button} ${styles.header3ButtonSearch}`}
              disabled={creatingShoppingCart}
              onClick={() => {
                setShowSearchBar(true);
              }}>

              <span className={`${styles.header3ButtonIcon} icon-search`} />
            </button>
            <button
              role={"button"}
              aria-label='Botón principal de carrito'
              className={`${styles.header3Button} ${
              !!cartProductsQuantity && styles.active
              }`}
              onClick={handleCartButton}>

              <span
                className={`${styles.header3ButtonIcon} icon-cart-outline`} />

              {!!cartProductsQuantity &&
              <span className={styles.header3ButtonBadge}>
                  {cartProductsQuantity}
                </span>}

            </button>
          </div>
        </div>
        <nav className={styles.header3Menu}>
          <ul className={styles.header3Items}>
            <li className={styles.header3Item}>
              <AppLink
                to={`${pathname}/${makeUrl(pathname, "")}`}
                className={({ isActive }) =>
                `${styles.header3MenuLink} ${isActive ? styles.active : ""}`}

                Component={ComponentLinks}
                onClick={() =>
                logEvent(MainHeaderEvents.SelectHeaderHome, {
                  Template_id: themeContext.templateId
                })}>


                {t("main_header.home")}
              </AppLink>
            </li>
            {categories && !!categories.length &&
            <li
              className={`${styles.header3Item} ${
              showCategoriesMenu ? styles.active : ""
              }`}>

                <span
                className={`${styles.header3MenuLink} ${
                isInCategoryView ? styles.active : ""
                }`}
                onClick={handleShowCategoriesList}>

                  {t("main_header.categories")}
                  <span className={`${styles.arrowDown} icon-arrow-2`} />
                </span>
                <div
                ref={categoriesListRef}
                className={`${styles.header3SubItems} ${
                styles.header3SubMenuContainer
                } ${
                categories.length > HEADER_CATEGORIES_EXTEND_ITEMS ?
                styles.expand :
                ""
                } ${categoriesChunks.length > 2 ? styles.center : ""}`}>

                  <h4 className={styles.header3SubItemsTitle}>
                    {t("main_header.categories")}
                  </h4>
                  <nav className={styles.header3CategoriesChunks}>
                    {categoriesChunks.map((categoriesChunk, indexChunk) =>
                  <ul
                    className={styles.header3Categories}
                    key={`header-category-chunk-${indexChunk}`}>

                        {categoriesChunk.map((item, index) =>
                    <li
                      className={styles.header3SubItem}
                      key={`header-category-${index}`}>

                            <span className={`${styles.header3SubMenuLink}`}>
                              <AppLink
                          to={`${pathname}/${makeUrl(
                            pathname,
                            `categoria/${categoryNormalize(
                              item.category.id
                            )}`
                          )}`}
                          className={styles.header3CategoryLink}
                          onClick={() =>
                          handleClickOnCategory(item.category)}>


                                {item.category.name}
                              </AppLink>
                              {item.subCategories &&
                        <button
                          className={`${styles.header3CategoryButton} ${
                          categoryListSelected === item &&
                          styles.active
                          }`}
                          onClickCapture={() => {
                            handleSelectCategoryList(item);
                          }}>

                                  <span className='icon-arrow-2' />
                                </button>}

                            </span>
                            {item.subCategories &&
                      categoryListSelected === item &&
                      <ul className={styles.header3SubCategories}>
                                  {item.subCategories.map(
                          (subItem, subIndex) =>
                          <li
                            className={styles.header3SubItem}
                            key={`header-subcategory-${index}-${subIndex}`}>

                                        <AppLink
                              to={`${pathname}/${makeUrl(
                                pathname,
                                `categoria/${categoryNormalize(
                                  item.category.id
                                )}/${categoryNormalize(
                                  subItem.id
                                )}`
                              )}`}
                              className={`${styles.header3CategoryLink}`}>

                                          {subItem.name}
                                        </AppLink>
                                      </li>

                        )}
                                </ul>}

                          </li>
                    )}
                      </ul>
                  )}
                  </nav>
                </div>
              </li>}

            {menuItems.map((item, index) =>
            <li className={styles.header3Item} key={`menu-item-${index}`}>
                {item.link &&
              <AppLink
                to={item.link}
                className={({ isActive }) =>
                `${styles.header3MenuLink} ${
                isActive ? styles.active : ""
                }`}

                Component={ComponentLinks}
                onClick={item.onClick || undefined}>

                    {item.text}
                  </AppLink>}

                {!item.link &&
              <span
                className={`${styles.header3MenuLink} ${
                item.isActive ? styles.active : ""
                }`}
                onClick={item.onClick || undefined}>

                    {item.text}
                  </span>}

              </li>
            )}
          </ul>
        </nav>
      </div>
      {showHeaderDetail &&
      <MainHeaderSideMenu
        categories={categories}
        hasOffers={hasOffers}
        hasServices={hasServices}
        hasWholesale={hasWholesale}
        theme={theme}
        storeMetadata={storeMetadata}
        onClose={() => setShowHeaderDetail(false)}
        data={data} />}


      {showCartEmpty &&
      <CartEmpty
        className={styles.header3CartEmpty}
        onClose={() => setShowCartEmpty(false)} />}


    </header>);

};

export default Header3;